import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ArthaLogo } from "./ArthaLogo";
import { ThemeToggle } from "./ThemeToggle";
import { CurrencySelector } from "./CurrencySelector";
import { useTheme } from "@/lib/theme";
import { ArrowUpRight } from "lucide-react";

const links = [
  { to: "/countries", label: "Countries" },
  { to: "/pricing", label: "Pricing" },
  { to: "/partners", label: "Partner Network" },
  { to: "/resources", label: "Resources" },
];

const MarketingNav = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  return (
    <header
      className={`sticky top-0 z-50 backdrop-blur-xl border-b border-border-subtle ${
        isDark ? "bg-[rgba(13,13,12,0.72)]" : "bg-[rgba(250,247,242,0.72)]"
      }`}
      data-testid="marketing-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <ArthaLogo size={26} variant={isDark ? "light" : "dark"} />
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-tight transition-colors ${isActive ? "text-ink-body" : "text-ink-muted hover:text-ink-body"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <CurrencySelector />
          <ThemeToggle />
          <Link
            to="/login"
            data-testid="nav-login"
            className="hidden sm:inline-block text-sm text-ink-muted hover:text-ink-body transition-colors"
          >
            Sign in
          </Link>
          <Link
            to="/signup"
            data-testid="nav-get-started"
            className={`group inline-flex items-center gap-1.5 px-4 py-2 text-sm tracking-tight transition-all duration-300 ${
              isDark
                ? "bg-artha-amber text-artha-ink hover:bg-artha-cream"
                : "bg-artha-ink text-artha-cream hover:bg-artha-amber hover:text-artha-ink"
            }`}
          >
            Incorporate
            <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default MarketingNav;
